import React, { useEffect, useRef } from 'react';
import { Disc3 } from 'lucide-react';
import { useDecks } from '@/features/player/PlayerProvider';
import { useIsTouchDevice } from '@/hooks/useIsTouchDevice';
import DeckPane from './components/DeckPane';
import Crossfader from './components/Crossfader';
import BrowserDrawer from './components/BrowserDrawer';

const Decks: React.FC = () => {
  const isTouch = useIsTouchDevice();
  const { enter, exit } = useDecks();
  const bootRef = useRef({ enter, exit });
  bootRef.current = { enter, exit };

  useEffect(() => {
    if (isTouch) return;
    bootRef.current.enter();
    return () => bootRef.current.exit();
  }, [isTouch]);

  if (isTouch) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-meradio-cream dark:bg-bg-dark-primary px-6">
        <div className="text-center max-w-sm">
          <Disc3 className="w-12 h-12 text-meradio-primary mx-auto mb-4" />
          <h1 className="text-xl font-bold text-meradio-dark dark:text-text-dark-primary mb-2">
            The booth needs a desktop
          </h1>
          <p className="text-meradio-dark-light dark:text-text-dark-secondary">
            DJ mode runs two synced players and precise volume control that touch devices cannot drive.
            Open it on a desktop browser.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-meradio-cream dark:bg-bg-dark-primary p-4 md:p-6">
      <div className="sticky top-0 z-30 bg-meradio-cream dark:bg-bg-dark-primary pb-3 pt-2 grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-4 lg:gap-6 items-stretch shadow-[0_8px_16px_-8px_rgba(0,0,0,0.4)]">
        <DeckPane deckId="a" />
        <Crossfader />
        <DeckPane deckId="b" />
      </div>
      <div className="mt-6">
        <BrowserDrawer />
      </div>
    </div>
  );
};

export default Decks;
